const SEDES = [
  {
    title: "Calle 16",
    address: "Calle 16#6-66",
    phone: "(2) 373 2770",
    phone_aux: "313 731 6152",
    email: "luz@aglocol.com",
    coordinator: "Luz Garcia",
  },
  {
    title: "Lopez",
    address: "Carrera 8#74-11",
    phone: "(2) 379 7995",
    phone_aux: "311 300 1034",
    email: "alfonsolopez@aglocol.com",
    coordinator: "Luz Adriana Herrera",
  },
  {
    title: "Calle 70",
    address: "Calle 70 #7R bis 131",
    phone: "312 366 5217",
    phone_aux: "",
    email: "calle70@aglocol.com",
    coordinator: "Jose Chalacan",
  },
  {
    title: "Alameda",
    address: "Carrera 22#8 A-34",
    phone: "(2) 374 1090",
    phone_aux: "321 820 8431",
    email: "alameda@aglocol.com",
    coordinator: "Gloria Paz",
  },
  {
    title: "Diamante",
    address: "Carrera 29#39 A-113",
    phone: "(2) 379 8004",
    phone_aux: "314 678 7988",
    email: "diamante@aglocol.com",
    coordinator: "Eider Cisneros",
  },
  {
    title: "Simon Bolivar",
    address: "Calle 36#31-13",
    phone: "312 366 5162",
    phone_aux: "(2) 308 8042",
    email: "simonbolivar@aglocol.com",
    coordinator: "David Ortiz",
  },
  {
    title: "Palmira",
    address: "Calle 41#27-47",
    phone: "(2) 285 5810",
    phone_aux: "321 721 9415",
    email: "palmira@aglocol.com",
    coordinator: "Sebastian Sanchez",
  },
  {
    title: "Tulua",
    address: "Carrera 30 #11 02",
    phone: "(2) 230 3196",
    phone_aux: "310 414 4420",
    email: "tulua@aglocol.com",
    coordinator: "Jenner Rojas",
  },
  {
    title: "Popayan",
    address: "Calle 3 #11-46",
    phone: "(2) 836 7978",
    phone_aux: "320 677 3345",
    email: "popayan@aglocol.com",
    coordinator: "Robinson Molina",
  },
  {
    title: "Dosquebradas",
    address: "Transversal 10 #9-309, Bodega 4, Zona Industrial La Macarena",
    phone: "312 794 0587",
    phone_aux: "",
    email: "pereira@aglocol.com",
    coordinator: "",
  },
  {
    title: "Armenia",
    address: "Carrera 20#23-39 centro",
    phone: "731 2448",
    phone_aux: "320 497 9685",
    email: "agloarmenia@aglocol.com",
    coordinator: "Yeiner Cancimance",
  },
];

export { SEDES };
